import styled from "styled-components";
import { DashboardTemplate } from "templates/DashboardTemplate";

export const Container = styled.div`
  .containerClass {
    display: flex;
    flex-direction: column;

    padding: 2rem 3rem;

    height: 100vh;

    overflow-y: scroll;
  }
`;

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  width: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 97%;
`;

export const MapContainer = styled.div`
  margin-top: 1rem;
  border-radius: 4px;
  height: 100%;

  @media (min-width: 1400px) {
    height: auto;
  }
`;
